/** GxChipSelect: a choice from a short list, drawn as a chip (the Decide rationale's "You expect" control); a native select underneath for keyboard and screen readers. A `null` value shows the placeholder: nothing chosen yet. */
export function GxChipSelect<V extends string | number>({ label, value, options, onChange, soft = false, suggested = false, placeholder = "Choose" }: {
  readonly label: string; readonly value: V | null; readonly options: readonly (readonly [V, string])[]; readonly onChange: (v: V) => void; readonly soft?: boolean; readonly suggested?: boolean; readonly placeholder?: string;
}) {
  return (
    <label className={suggested ? "gx-chip gx-chip--suggested" : soft ? "gx-chip gx-chip--soft" : "gx-chip"}>
      <span className="gx-sr">{label}</span>
      <select aria-label={label} value={value === null ? "" : value} onChange={(e) => { const hit = options.find(([v]) => String(v) === e.target.value); if (hit !== undefined) onChange(hit[0]); }}>
        {value === null ? <option value="" disabled>{placeholder}</option> : null}
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </label>
  );
}
